import React, { Component } from "react";
import { observer, inject } from "mobx-react";

@inject("userStore")
@observer
export default class UserInfoComponent extends Component {
  render() {
    const {
      getDevUser,
      get_obj_userData,
      changeDevUser,
    } = this.props.userStore;

    const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";
    return !IS_BIRD_APP? (
      <div
        style={{
          color: process.env.NODE_ENV.includes("development")
            ? "black"
            : "white",
        }}
      >
        {process.env.NODE_ENV.includes("development") ? (
          <div style={{ display: "flex" }}>
            <select
              value={getDevUser}
              onChange={(e) => changeDevUser(e.target.value)}
            >
              <option value="flammapa">flammapa</option>
              <option value="michalpazitny">michalpazitny</option>
              <option value="tamasmenesi">tamasmenesi</option>
              <option value="petermagyar">petermagyar</option>
              <option value="pepitavdheiligenberg">pepitavdheiligenberg</option>
              <option value="dominiklin">dominiklin</option>
              <option value="andreanovello">andreanovello</option>
              <option value="mariavelasco">mariavelasco</option>
            </select>
            <span style={{ color: "white", padding: "5px 10px" }}>
              {get_obj_userData.actor?.name}
            </span>
          </div>
        ) : (
          <div style={{ display: "flex" }}>
            <span style={{ color: "white", padding: "5px 10px" }}>
              {get_obj_userData.actor?.name}
            </span>
          </div>
        )}
      </div>
    ): null;
  }
}
